import { BaseApiClient } from '@/services/baseApiClient';
import type { RequestOptions } from '@/utils/request';
import { getQuery } from '@/components/filter/helpers';
import type { AnalysisDataResponse, AnalysisFilter } from '@/services/api/analysis';
import type { AnalysisType } from '@enmon/commons/lib/enmon';

export class ExternalDataApiClient extends BaseApiClient {
  constructor() {
    super('api/external-data');
  }

  public analysis(
    analysisType: AnalysisType,
    dataTypes: string[],
    filter: AnalysisFilter,
    signal: RequestOptions['signal'],
  ): Promise<AnalysisDataResponse | null> {
    return this.http.get(`analysis/${analysisType}`, {
      query: getQuery({ ...filter, types: dataTypes }),
      signal,
    });
  }
}
